import React from "react";

import { makeStyles, Typography } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import DescriptionIcon from "@material-ui/icons/Description";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import PropTypes from "prop-types";
import { Link, useRouteMatch } from "react-router-dom";

const useStyles = makeStyles(
  ({ breakpoints, palette: { custom, primary } }) => ({
    root: {
      margin: 0,
      padding: 0,
    },
    item: {
      padding: 0,
      "&.Mui-selected::before": {
        content: "''",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        width: 4,
        background: primary.main,
      },
    },
    itemLink: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: 56,
      color: custom.low,
      textDecoration: "none",
      [breakpoints.down("md")]: {
        flexDirection: "row",
        justifyContent: "flex-start",
      },
    },
    itemIcon: {
      opacity: 0.78,
      fontSize: 20,
      [breakpoints.down("md")]: {
        width: 60,
      },
    },
    itemText: {
      opacity: 0.56,
      fontSize: "0.8rem",
      [breakpoints.down("md")]: {
        fontSize: "1rem",
        opacity: 0.8,
      },
    },
  })
);

const menu = [
  {
    Icon: PlayCircleOutlineIcon,
    text: "Intro",
    to: "/",
  },
  {
    Icon: DescriptionIcon,
    text: "Docs",
    to: "/docs",
  },
  {
    Icon: DesktopWindowsIcon,
    text: "Examples",
    to: "/examples",
  },
  {
    Icon: AccountBoxIcon,
    text: "Author",
    to: "/author",
  },
];

function MainMenu(props) {
  const { onCloseMenu } = props;

  const classes = useStyles();

  const match = useRouteMatch("/:base");
  const base = `/${match?.params?.base || ""}`;

  return (
    <List className={classes.root}>
      {menu.map(({ Icon, text, to }) => (
        <ListItem key={to} className={classes.item} selected={to === base}>
          <Link className={classes.itemLink} to={to} onClick={onCloseMenu}>
            <Icon className={classes.itemIcon} />
            <Typography className={classes.itemText}>{text}</Typography>
          </Link>
        </ListItem>
      ))}
    </List>
  );
}

MainMenu.propTypes = {
  onCloseMenu: PropTypes.func,
};

MainMenu.defaultProps = {
  onCloseMenu: () => {},
};

export default React.memo(MainMenu);
